import "../css/depthChart.css";
import teamsBasic from "../data/teamsBasic2025.json";
import { UseStandingsConf } from "../hooks/getStandings";
import { GetDepthRow, useDepthChart } from "../hooks/getDepthCharts";
import { darkTeams, noShadowTeams } from "../hooks/vars";
import { GetTeamRecord } from "../hooks/getTeamData";

function DepthChartGrid() {
  //props k= team key
  const teamData = teamsBasic; //Name, HeadCoach
  // const confs = ["AFC", "NFC"];
  // const divs = ["North", "East", "South", "West"];

  let divRankArr = getDivRankings();
  //console.log(teamData);
  //console.log(divRankArr);
  // if (divRankArr[0] === "error") {
  //   console.log(divRankArr[1]);
  //   return;
  // }
  const sortByDiv = teamData.sort((a, b) => {
    let divRankA = divRankArr?.find((t) => t[0] === a.Key);
    if (!divRankA) {
      divRankA = [a.Key, 4];
    }

    let divRankB = divRankArr?.find((t) => t[0] === b.Key);
    if (!divRankB) {
      divRankB = [b.Key, 4];
    }

    if (a.Conference < b.Conference) {
      return -1;
    }
    if (a.Conference > b.Conference) {
      return 1;
    }
    if (a.Division < b.Division) {
      return -1;
    }
    if (a.Division > b.Division) {
      return 1;
    }
    if (divRankA[1] < divRankB[1]) {
      return -1;
    }
    if (divRankA[1] > divRankB[1]) {
      return 1;
    }
    if (a.Name < b.Name) {
      return -1;
    }
    if (a.Name > b.Name) {
      return 1;
    }
    return 0;
  });

  //console.log(sortByDiv)
  const result = sortByDiv.map((t, i) => {
    let r = i + 1;
    if (r > 4 && r < 9) {
      r = r - 4;
    }
    if (r > 8 && r < 13) {
      r = r - 8;
    }
    if (r > 12 && r < 17) {
      r = r - 12;
    }
    if (r > 16 && r < 21) {
      r = r - 16;
    }
    if (r > 20 && r < 25) {
      r = r - 20;
    }
    if (r > 24 && r < 29) {
      r = r - 24;
    }
    if (r > 28 && r < 33) {
      r = r - 28;
    }

    return (
      <div
        className={t.Key + " starterRow"}
        key={t.Key}
        style={{
          background:
            "linear-gradient(0deg,#000 -150%, #" +
            t.PrimaryColor +
            " 80%, #ffffffff 500%)",
          color: darkTeams.includes(t.Key)
            ? "#" + t.TertiaryColor
            : "#" + t.SecondaryColor,
          textShadow: noShadowTeams.includes(t.Key)
            ? ".5px .5px 0px #ffffff36"
            : "1px 1px 0 #00000085",
        }}
      >
        <div className="divName">
          {t.Conference} {t.Division}
        </div>
        <div
          className="tinyLogo"
          style={{
            backgroundImage: "url(" + t.WikipediaLogoURL + ")",
          }}
        ></div>
        <div>{r++}</div>
        <div className="teamName" style={{ textTransform: "uppercase" }}>
          {t.Name}{" "}
        </div>
        <div className="depthRecord">
          <GetTeamRecord t={t.Key} />
        </div>
        <div>{t.HeadCoach}</div>
        <GetDepthRow k={t.Key} />
      </div>
    );
  });
  return <>{result}</>;
}

function DepthChartModule() {
  return (
    <>
      <div className="defaultModal depthModal">
        <div className="starterGrid">
          <div className="topRow">
            <div>#</div>
            <div>Team</div>
            <div>W/L/T</div>
            <div>Head Coach</div>
            <div>QBs</div>
            {/* <div>QB2</div> */}
            <div>WRs</div>
            {/* <div>WR2</div> */}
            <div>RBs</div>
            {/* <div>RB2</div> */}
            <div>TEs</div>
          </div>
          <DepthChartGrid />
        </div>
        <RefetchDepthButton />
      </div>
    </>
  );
}

function RefetchDepthButton() {
  const { refetch } = useDepthChart();
  return (
    <>
      <button className="toggleButton refetchButton" onClick={refetch}>
        Refetch Depth Chart
      </button>
    </>
  );
}

function getDivRankings() {
  const { data, isLoading, error } = UseStandingsConf();
  if (isLoading) return;
  <div>Loading team data...</div>;
  if (error) {
    console.log("Error loading team data: " + error.message);
    return <>E</>;
  }
  //console.log(data)
  let divRankList = Object.values(data).slice(1, 2);
  divRankList = divRankList[0];

  //console.log(divRankList)
  const divRankings = divRankList.map((data, i) => {
    const t = data.teamAbv;
    return [t, i + 1];
  });

  //console.log(divRankings)

  return divRankings;
}

export default DepthChartModule;
